import apiClient from '../index';

export const invitationApi = {
    // GET /api/guests/invitation — Invitation list
    getInvitationList: (params = {}) => apiClient.get('/guests/invitation', { params }),

    // POST /api/guests/search-by-card — Search invitation by card number
    searchByCard: (cardNumber) => apiClient.post('/guests/search-by-card', { card_number: cardNumber }),

    // GET /api/guests/invited — List invited guests
    getInvitedGuests: (params = {}) => apiClient.get('/guests/invited', { params }),

    // GET /api/guests/attendance — Attendance list
    getAttendanceList: (params = {}) => apiClient.get('/guests/attendance', { params }),

    // POST /api/guests/mark-attendance — Mark attendance
    markAttendance: (data) => apiClient.post('/guests/mark-attendance', data),

    // POST /api/guests/thank-note — Thank-note list
    getThankNoteList: (params = {}) => apiClient.get('/guests/thank-note', { params }),

    // GET /api/invitation-rsvp/{guestId} — Get RSVP details for a guest
    getInvitationRsvp: (guestId) => apiClient.get(`/invitation-rsvp/${guestId}`),

    // POST /api/invitation-rsvp — Record RSVP from invited guest (Public & Admin)
    recordRsvp: async (guestId, data = {}) => {
        const id = guestId || data?.guest_id;
        const payload = {
            guest_id: Number(id) || id,
            rsvp: Number(data?.rsvp) || data?.rsvp || 1,
            submit: 'Hakiki',
            ...data
        };
        try {
            return await apiClient.post('/invitation-rsvp', payload);
        } catch (err) {
            // Fallback if live server expects path param or mark-attendance
            if (err?.response?.status === 405 || err?.response?.status === 404) {
                try {
                    return await apiClient.post(`/invitation-rsvp/${id}`, payload);
                } catch (fallbackErr) {
                    return await apiClient.post('/guests/mark-attendance', payload);
                }
            }
            throw err;
        }
    },

    // GET /api/export/invitations/{type} — Export invitations as a downloadable file
    exportInvitations: async (type = 'pdf', filename = 'invitations') => {
        const response = await apiClient.get(`/export/invitations/${type}`, {
            responseType: 'blob',
        });
        const blob = response instanceof Blob ? response : new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${type}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    },
};

export default invitationApi;
